/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Group_SetupInputs */



/**
* | output |
* | --- |
* | "Set up" |
*
* @param {Tools_Group_SetupInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tools_group_setup = /** @type {((inputs?: Tools_Group_SetupInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Group_SetupInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Préparation")
	if (locale === "es") return /** @type {LocalizedString} */ ("Preparación")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Preparação")
	if (locale === "it") return /** @type {LocalizedString} */ ("Preparazione")
	return /** @type {LocalizedString} */ ("Set up")
});